import React, { useState, useEffect } from 'react';
import {
  Button,
  Col,
  Form,
  FormInput,
  FormResetButton,
  InlineEditColumnProps,
  Row,
  Table,
} from '@digital/ui';

import { Card, Tooltip, Icon } from 'antd';
import { ProjetoJoinCicloOrcamentario } from '@app/api/projeto';
import { CrfCicloOrcamentarioHasJoinProjeto } from '@app/api/crf/crfcicloorcamentario';
import { compareText } from '@app/helpers/comparators';

interface Props {
  titulo: string;
  cicloOrcamentarioId: string;
  data: CrfCicloOrcamentarioHasJoinProjeto[];
  handleJoinProjeto(cicloOrcamentarioId: string): Promise<unknown>;
}

const initialState: ProjetoJoinCicloOrcamentario = {
  id: '',
  nome: '',
  codigo: '',
  numero: '',
  index: 0,
};

const CrfCicloOrcamentarioTable = ({ titulo, data, handleJoinProjeto, cicloOrcamentarioId }: Props) => {

  const [projetos, setProjetos] = useState<ProjetoJoinCicloOrcamentario>(initialState);

  useEffect(() => {
    const getProjetosData = async () => {
      const result = await handleJoinProjeto(cicloOrcamentarioId);
      if (result) setProjetos(result);
    };

    getProjetosData();
  }, [cicloOrcamentarioId]);

  const customColumns = () => {
    return [
      {
        title: 'N',
        dataIndex: 'index',
        width: '1%',
      },
      {
        title: 'Código',
        dataIndex: 'codigo',
        width: '5%',
        sorter: (a, b) => compareText(a.codigo, b.codigo),
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar"
                name="codigo"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) => {
          try {
            if (record != undefined
              && record.hasOwnProperty('codigo')
              && record.codigo != null) {
              return record.codigo
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase())
            }
          } catch (e) {
          }
          return false;
        }
      },
      {
        title: 'Numero',
        dataIndex: 'numero',
        width: '5%',
        sorter: (a, b) => compareText(a.numero, b.numero),
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar"
                name="numero"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) => {
          try {
            if (record != undefined
              && record.hasOwnProperty('numero')
              && record.numero != null) {
              return record.numero
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase())
            }
          } catch (e) {
          }
          return false;
        }
      },
      {
        title: 'Nome do Projeto',
        dataIndex: 'nome',
        width: '15%',
        sorter: (a, b) => compareText(a.nome, b.nome),
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar"
                name="nome"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) => {
          try {
            if (record != undefined
              && record.hasOwnProperty('nome')
              && record.nome != null) {
              return record.nome
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase())
            }
          } catch (e) {
          }
          return false;
        }
      },
      {
        title: 'Id',
        dataIndex: 'id_Finplan',
        width: '5%',
        sorter: (a, b) => compareText(a.id_Finplan, b.id_Finplan),
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar"
                name="id_Finplan"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) => {
          try {
            if (record != undefined
              && record.hasOwnProperty('id_Finplan')
              && record.id_Finplan != null) {
              return record.id_Finplan
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase())
            }
          } catch (e) {
          }
          return false;
        }
      },
      {
        title: 'Diretoria',
        dataIndex: 'nomeDiretoria',
        width: '15%',
        sorter: (a, b) => compareText(a.nomeDiretoria, b.nomeDiretoria),
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar"
                name="nomeDiretoria"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) => {
          try {
            if (record != undefined
              && record.hasOwnProperty('nomeDiretoria')
              && record.nomeDiretoria != null) {
              return record.nomeDiretoria
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase())
            }
          } catch (e) {
          }
          return false;
        }
      },
      {
        title: 'Área',
        dataIndex: 'nomeArea',
        width: '15%',
        sorter: (a, b) => compareText(a.nomeArea, b.nomeArea),
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar"
                name="nomeArea"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) => {
          try {
            if (record != undefined
              && record.hasOwnProperty('nomeArea')
              && record.nomeArea != null) {
              return record.nomeArea
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase())
            }
          } catch (e) {
          }
          return false;
        }
      },
      {
        title: 'Departamento',
        dataIndex: 'nomeDepartamento',
        width: '15%',
        sorter: (a, b) => compareText(a.nomeDepartamento, b.nomeDepartamento),
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar"
                name="nomeDepartamento"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) => {
          try {
            if (record != undefined
              && record.hasOwnProperty('nomeDepartamento')
              && record.nomeDepartamento != null) {
              return record.nomeDepartamento
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase())
            }
          } catch (e) {
          }
          return false;
        }
      },
      {
        title: 'Escopo Anual',
        dataIndex: 'escopoAnual',
        width: '40%',
        render: (text, record) => {
          return (<Tooltip title={record.escopoAnual}>
            <p className={'text-limit-two-lines'}> {record.escopoAnual} </p>
          </Tooltip>
          );
        },
        sorter: (a, b) => compareText(a.codigo, b.codigo),
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar"
                name="escopoAnual"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) => {
          try {
            if (record != undefined
              && record.hasOwnProperty('escopoAnual')
              && record.escopoAnual != null) {
              return record.escopoAnual
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase())
            }
          } catch (e) {
          }
          return false;
        }
      },
      {
        title: 'Previsão',
        dataIndex: 'nomeTipoProjetoPrevisao',
        width: '5%',
        sorter: (a, b) => compareText(a.nomeTipoProjetoPrevisao, b.nomeTipoProjetoPrevisao),
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <Form>
            <Row>
              <FormInput
                placeholder="Pesquisar"
                name="nomeTipoProjetoPrevisao"
                style={{ marginTop: '15px' }}
                onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                onPressEnter={() => {
                  if (typeof confirm === 'function') confirm();
                }}
              />
            </Row>
            <Row>
              <Col span={6}>
                <Button
                  type="primary"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (typeof confirm === 'function') confirm();
                  }}
                  icon="commons-search"
                  size="small">
                  Pesquisar
                </Button>
              </Col>
              <Col span={6}>
                <FormResetButton
                  size="small"
                  style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                  beforeReset={() => {
                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                  }}>
                  Limpar
                </FormResetButton>
              </Col>
            </Row>
          </Form>
        ),
        filterIcon: filtered => {
          const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
          return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
        },
        onFilter: (value, record) => {
          try {
            if (record != undefined
              && record.hasOwnProperty('nomeTipoProjetoPrevisao')
              && record.nomeTipoProjetoPrevisao != null) {
              return record.nomeTipoProjetoPrevisao
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase())
            }
          } catch (e) {
          }
          return false;
        }
      }
    ] as InlineEditColumnProps<CrfCicloOrcamentarioHasJoinProjeto>[];
  };

  return (
    <>
      <Card title={titulo}>
        <Table
          className="removeScrollbar no-actions-table row-limit-two-lines"
          rowKey="id"
          columns={customColumns()}
          dataSource={data}
        />
      </Card>
    </>
  );
};

export default CrfCicloOrcamentarioTable;
